import React from 'react'

import NavigationPanel_QuickSearchResults from "./search-results"
import NavigationPanel_QuickSearchInput from "./input"
import TopNavigationQuickSearch from "./model/quick-search"

type Props = {
    onCloseModal?    : callback
}

// const debug = "NavigationPanel_QuickSearch"
const debug = false

export default class NavigationPanel_QuickSearch extends React.Component<Props, any>{


    public quickSearch          : TopNavigationQuickSearch;

    public input             : any
    public main              : any

    constructor(props: Props) {
        super(props);

        this.quickSearch = new TopNavigationQuickSearch();

        // console.count("Constructor")

    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<any>, nextContext: any): boolean {
        return false
    }

    componentWillUnmount() {
        this.quickSearch.delayedSearch.cancel()
    }

    onKeyDown = (event: React.KeyboardEvent) => {

        switch(event.key) {

            case 'Escape':
                return gd.modal.hide()

            case 'ArrowUp':
                return this.quickSearch.keyboardIterator.moveUp()

            case 'ArrowDown':
                return this.quickSearch.keyboardIterator.moveDown()

            case 'Enter':
                if (!_.isNull(this.quickSearch.keyboardIterator.currentIndex)) {
                    const searchResult = this.quickSearch.results.items[this.quickSearch.keyboardIterator.currentIndex]
                    searchResult.onClick?.()
                }
                return
        }
    }



    render(): React.ReactNode {

        debug && console.log(debug, "render()")

        return (
            <div className="search flex-column-center-top" onKeyDown={this.onKeyDown}>

                <NavigationPanel_QuickSearchInput quickSearch={this.quickSearch} />

                <NavigationPanel_QuickSearchResults quickSearch={this.quickSearch} />

            </div>
        );
    }
}
